// dependencies imports ⇒
import React from "react";
// assets and scss imports ⇒
import "./abhaOtpContainer.scss";
import OTPInput from "../../../common/OTPInput";
import PrimaryButton from "../../../common/Buttons/PrimaryButton";
import anthemLogo from "../../../../assets/anthem-logo.png";
import AbhaActionButton from "../../../AbhaViewContainer/common/AbhaActionButton";

// project file imports(UI components) ⇒

// const file imports(helper methods, etc) ⇒

const AbhaOtpContainer = (props) => {
  // const declarations ⇒
  const {
    otpLabel,
    otpContent,
    disabled,
    otpError,
    otpErrorMessage,
    hideTimerResendBtn,
    mobileVerificationFlow,
    handleOTPChange,
    handleResendOTP,
    handleSubmit,
  } = props;

  // let or var declarations ⇒

  // life cycle methods ⇒

  // API Calls ⇒

  // Helper methods ⇒

  // Actions ⇒

  // create UI ⇒
  const abhaHeader = () => {
    return <p className="aoc-otp-header">Create ABHA (Health ID) Card</p>;
  };
  const abhaOtpLabelUI = () => {
    return <div className="aoc-otp-label">{otpLabel}</div>;
  };

  const abhaOtpContentUI = () => {
    return <div>{otpContent}</div>;
  };

  const abhaOtpInput = () => {
    return (
      <div className="aoc-otp-wrapper">
        <OTPInput
          autoFocus
          hasError={otpError}
          timerUnit={1}
          hideTimerResendBtn={hideTimerResendBtn}
          errorMessage={otpErrorMessage}
          onChangeOTP={handleOTPChange}
          handleResendOTP={handleResendOTP}
        />
      </div>
    );
  };

  const abhaNumberContinueBtn = () => {
    return (
      <div className="anvv-continue-btn-wrapper">
        {mobileVerificationFlow ? (
          <AbhaActionButton
            title="Submit OTP"
            disabled={disabled}
            handleClick={handleSubmit}
          />
        ) : (
          <PrimaryButton
            title={"Continue"}
            disabled={disabled}
            handleButtonClick={handleSubmit}
          />
        )}
      </div>
    );
  };

  const abhaOtpContainerUI = () => {
    return (
      <div>
        {mobileVerificationFlow && abhaHeader()}
        {abhaOtpLabelUI()}
        {abhaOtpContentUI()}
        {abhaOtpInput()}
        {abhaNumberContinueBtn()}
      </div>
    );
  };
  return <div className="abha-otp-container">{abhaOtpContainerUI()}</div>;
};

// export ⇒

export default AbhaOtpContainer;
